import { z } from 'zod';

import { aggregationType } from '../aggregation-type-radio-toggle-group';

const scopeItemSchema = z.object({
  id: z.string(),
  description: z.string(),
});

const scopeItemValue = z.nullable(z.array(scopeItemSchema)).optional();

export const downloadAssortmentTemplateFormSchema = z.object({
  aggregationType: aggregationType,
  filters: z.object({
    geographic: z.object({
      locationTypes: scopeItemValue,
      regions: scopeItemValue,
      countries: scopeItemValue,
      locations: scopeItemValue,
    }),
    product: z.object({
      departments: scopeItemValue,
      subDepartments: scopeItemValue,
      brands: scopeItemValue,
      seasons: scopeItemValue,
      events: scopeItemValue,
      collectionTypes: scopeItemValue,
      manufacturers: scopeItemValue,
      classes: scopeItemValue,
      subClasses: scopeItemValue,
      productGroups: z.array(z.string()).nullable().optional(),
      productIds: z.array(z.string()).nullable().optional(),
    }),
    locationClusters: z.array(z.string()).nullable().optional(),
  }),
});

export type DownloadAssortmentTemplateFormSchema = z.infer<
  typeof downloadAssortmentTemplateFormSchema
>;
